<div class="career-plans">
  <opac-user-title [title]="titleLabel | translate"></opac-user-title>

  <ng-container *ngIf="careerPlan && careerPlanLoaded">
    <opac-user-section>
      <h2 slot="header">
        <span class="title">{{ titleLabel | translate }}</span>
        <span class="subtitle">{{ careerPlan.name }}</span>
      </h2>

      <div class="career-plans__positions" *ngIf="showCareerPlanPositions">
        <app-career-plan-position [positionType]="'ACTUAL'" [positionName]="careerPlan.actualPosition"></app-career-plan-position>
        <app-career-plan-position [positionType]="'FUTURE'" [positionName]="careerPlan.futurePosition"></app-career-plan-position>
      </div>

      <div class="career-plans__skills">
        <app-skills-row *ngFor="let skillsRow of skillRows" [skills]="skillsRow"></app-skills-row>
      </div>
    </opac-user-section>
  </ng-container>

  <ng-container *ngIf="careerPlanHistory$ | async as completedCareerPlans">
    <opac-user-section *ngIf="completedCareerPlans.finishedCareerPlans.length > 0" [title]="completedHistoryLabel | translate">
      <app-career-plan-history [completedCareerPlans]="completedCareerPlans"> </app-career-plan-history>
    </opac-user-section>
  </ng-container>
</div>
